var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusDoNotDisturb = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  fill: "var(--red-core)",
  rx: 5.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4 6h4"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  stroke: "currentColor",
  rx: 5.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusDoNotDisturb);
export default ForwardRef;